import { number, object, string } from 'yup'
import { createSsidPassphraseSchema } from 'utils/ssid-passphrase'

const validationRan = (t, { withStimeFields = false } = {}) =>
  object({
    name: string().required(t('ran.create.error_name')),
    ...(withStimeFields && {
      ssid_id: string().required(t('ran.form.error_ssid', 'Veuillez sélectionner un SSID')),
      vlan: number()
        .typeError(t('ran.form.error_vlan', 'Veuillez sélectionner un VLAN'))
        .required(t('ran.form.error_vlan', 'Veuillez sélectionner un VLAN')),
      wifi_psk: createSsidPassphraseSchema(t)
        .notRequired()
        .transform(value => value || undefined),
    }),
  })

export default validationRan
